import $ from 'jquery';
import _ from 'underscore';
import debounceViaRequestAnimationFrame from './debounce_animation_frame';

export default () => {
    $(function () {
        const $window = $(window);

        // Make scroll updates smoother by "debouncing" them to be performed not more than once per animation frame (if supported)
        let totalHeights = 0;
        const $sidebar = $('.article-sidebar');
        const $content = $('.article-content');
        const $navBar = $('.navbar-brands-container');
        let navBarHeight = $navBar.height() + 30;
        let contentHeight = $content.height();

        if ($('.-watch').length > 0) {
            $sidebar.css({
                opacity: 1,
                position: 'relative'
            });
            return false; // prevent execution on watch pages
        }

        $sidebar.css({
            height: $('.article-wrapper').clientHeight - 50,
            position: 'relative'
        });

        const children = $sidebar.children();
        const childrenLength = children.length;

        const topMargin = 400;
        const bottomMargin = 100;
        const interAdsMargin = 30;

        const contentHeightWithMargin = contentHeight - bottomMargin;

        let setScrollingBounds = (current, next) => {
            if (!current) {
                return false;
            }

            let adjustVerticalPosition = (maxY) => {
                /**
                 * NOTE: window.scrollY is not IE-compatible (window.pageYOffset is), however IE has problems with scroll event timing,
                 *       so it's better to keep it "disabled" for IE till the code is "fixed" position logic is used instead
                 */
                let y = window.scrollY + navBarHeight - $sidebar.offset().top;
                let $el = current.$el;
                let currentTop = current.top;

                if (y < currentTop) {
                    y = currentTop;
                } else {
                    let bottomBound = maxY - current.$el.height();
                    if (y > bottomBound) {
                        y = bottomBound;
                    }
                }
                $el.css({
                    top: y + 'px'
                });
            };

            if (!next) {
                return $window.on('scroll', debounceViaRequestAnimationFrame(() => {
                    adjustVerticalPosition(contentHeightWithMargin);
                }));
            }

            // handle default here
            $window.on('scroll', debounceViaRequestAnimationFrame(() => {
                adjustVerticalPosition(next.top - interAdsMargin);
            }));
        };

        let sideBarData = new Array(childrenLength);

        let initializationPhase = true;

        $window.on('fc:adsheightchanged', () => {
            const headerAdBottom = (() => {
                let headerImu = document.getElementById('header-imu');
                if (headerImu) {
                    return headerImu.clientHeight;
                }
                return 0;
            }());

            // start 400px from top OR after the header ad
            const effectiveTopMargin = Math.max(topMargin, headerAdBottom + 10);
            // How much max distance should be for each sidebar items
            const distance = ((contentHeight - effectiveTopMargin) / (childrenLength));

            const $children = _.map(children, (el) => {
                let $el = $(el);
                totalHeights += $el.height();
                return $el;
            });

            let initialDistance = effectiveTopMargin;

            _.each($children, ($el, index) => {
                let height = 0;
                if (index !== 0) {
                    // Get the previous element's height
                    height = $children[index - 1].height();

                    // we want to make sure the height of the item is never exceeding
                    // the max distance, if it is, then calculate the height as the distance
                    if (height < distance) {
                        height = distance;
                    }

                    // Increment the initialDistance with height padded to it and set its CSS.
                    initialDistance += height;
                }

                if (initializationPhase) {
                    // We are setting element positions the first time
                    $el.css({
                        position: 'absolute',
                        top: initialDistance,
                        left: 0
                    });

                    sideBarData[index] = {
                        $el: $el,
                        top: initialDistance
                    };
                } else if (sideBarData[index].top !== initialDistance) {
                    // We are updating the positions
                    sideBarData[index].top = initialDistance;
                    // If the element is above the upper bound of the range, push it down
                    // NOTE: children() iteration happens in the DOM order, so the elements are vertically ordered
                    if (parseInt($el.css('top'), 10) < initialDistance) {
                        $el.css({
                            top: initialDistance
                        });
                    }
                }
            });
        });

        $window.trigger('fc:adsheightchanged');

        initializationPhase = false;

        _.each(sideBarData, (current, index) => {
            setScrollingBounds(current, sideBarData[index + 1]);
        });

        $sidebar.css('opacity', 1);
    });
};
